
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "users",
  "title": "Users",
  "sidebar_label": "Accounts"
};
const slug = 'users';
const tableOfContents = [{
  "title": "Every individual is a unique user.",
  "slug": "every-individual-is-a-unique-user",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"every-individual-is-a-unique-user"} nextElement={{
      "type": "paragraph"
    }}>Every individual is a unique user.</_Heading>
    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#a72d365c-a2fd-456d-99bb-a74ea9ffbc07"
      }}>{`API-REFERENCE`}</a></p>
    <p>{`Every user who walks into a shop in a shopping mall is considered a user in Tradly. Similarly, every merchant who runs a shop is also considered a user. In Tradly, all users, whether they are customers or merchants, are referred to as “Users”, and their unique details are stored in the user section. You can find information about their purchases or the accounts they own.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
